import ReportContent from '@app/components/reports/components/report-content';
import { CompanyReportCategoryStatusStatusEnum } from '@shared/api/types';
import Text from '@shared/components/content/text';
import TextList from '@shared/components/content/text-list';
import { useCCFReportResult } from '../../ccf-report-result-context';
import { scope3StatusesToDisplay } from '../introduction/your-full-calculation';

export default function Scope3CoverageAppendix() {
  const {
    result: { scope3, includesScope3 },
  } = useCCFReportResult();

  if (!includesScope3) {
    return (
      <ReportContent>
        <Text variant="reportBody">
          This report does not include any Scope 3 emissions.
        </Text>
      </ReportContent>
    );
  }

  const { includedCats, excludedCats } = scope3.categories.reduce(
    (acc, category) => {
      if (
        scope3StatusesToDisplay.includes(
          category.status as CompanyReportCategoryStatusStatusEnum
        )
      ) {
        acc.includedCats.push(category);
      } else {
        acc.excludedCats.push(category);
      }
      return acc;
    },
    {
      includedCats: [] as typeof scope3.categories,
      excludedCats: [] as typeof scope3.categories,
    }
  );

  return (
    <ReportContent>
      <>
        <Text variant="reportBody">
          Scope 3 encompasses all indirect emissions that are not covered under
          Scope 2, occurring across the entire value chain. This includes both
          upstream and downstream activities, such as supply chain operations,
          business travel, and the end-of-life treatment of sold products.
          <br />
          <br />
          This report specifically includes:
        </Text>
        <TextList className="space-y-2 text-md">
          {includedCats.map((category) => (
            <li key={category.name}>
              <span className="font-medium">
                Category {category.scope3CategoryNumber}
              </span>{' '}
              - {category.name}
            </li>
          ))}
        </TextList>
      </>
      <>
        <Text variant="h3">Excluded Scope 3 categories</Text>
        <div className="space-y-4">
          <Text variant="reportBody">
            The following categories are excluded from this report as they are
            not deemed significant for the reporting business:
          </Text>
          <TextList className="space-y-2 text-md">
            {excludedCats.map((category) => (
              <li key={category.name}>
                <span className="font-medium">
                  Category {category.scope3CategoryNumber}
                </span>{' '}
                - {category.name}
              </li>
            ))}
          </TextList>
        </div>
      </>
    </ReportContent>
  );
}
